var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusSolutionsLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.462,
    height: 30.001,
    viewBox: "0 0 37.462 30.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3073",
    "data-name": "Group 3073",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Status_Solutions_Logo-reverse-01",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M88.448,32.729,77.89,30.375l.034-.412L89.235,28.13a11.979,11.979,0,0,1-.787,4.6",
    transform: "translate(-51.774 -19.601)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M86.431,11.82l-8.163,6.435-.1.513,10.873-3.1a7.864,7.864,0,0,0-2.612-3.845",
    transform: "translate(-51.949 -9.404)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M80.43,5.58l-1.78,7.447,6.222-6.274A12.215,12.215,0,0,0,80.43,5.58",
    transform: "translate(-52.249 -5.502)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M36.851,5.375l.03,7.279a18.977,18.977,0,0,0-4.142-.427c-2.717-.019-7.174.825-7.777,4.49-.611,3.729,5.075,5.671,3.755,7.2C27.181,25.708,13.4,19.708,13.4,19.708A28.548,28.548,0,0,1,24.213,9.292c7.428-4.164,12.638-3.917,12.638-3.917",
    transform: "translate(-11.454 -5.373)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M9,50.38l10.558,2.357-.034.412L8.209,54.986A11.945,11.945,0,0,1,9,50.38",
    transform: "translate(-8.209 -33.511)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M11.8,67.379l8.167-6.435.1-.513L9.19,63.533A7.824,7.824,0,0,0,11.8,67.379",
    transform: "translate(-8.822 -39.795)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M25.558,72.793l1.784-7.443L21.12,71.62a12.149,12.149,0,0,0,4.438,1.173",
    transform: "translate(-16.281 -42.871)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M40.34,53.926l-.03-7.275a18.977,18.977,0,0,0,4.141.427c2.714.015,7.174-.825,7.773-4.49.611-3.729-5.075-5.671-3.755-7.2C50.006,33.6,63.787,39.6,63.787,39.6A28.607,28.607,0,0,1,52.974,50.017C45.55,54.174,40.34,53.926,40.34,53.926",
    transform: "translate(-28.279 -23.929)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSolutionsLogoMobile);
export default __webpack_public_path__ + "static/media/StatusSolutionsLogoMobile.3907922b73decdd4081963c7f0f50e3e.svg";
export { ForwardRef as ReactComponent };